import { SECOND } from '../utils/time';

const digitalSpanTestLevel = (level, digit) => ({
    practice: true,
    name: 'ทดลองเล่น',
    level,
    displayTime: 1 * SECOND,
    cooldownTime: 1 * SECOND,
    answerTime: 10* SECOND,
    digit,
})
const digitalSpanLevel = (level, digit) => ({
    name: 'ระดับที่ ' + level,
    level,
    displayTime: 1 * SECOND,
    cooldownTime: 1 * SECOND,
    answerTime: 5 * SECOND,
    digit,
})

export const FORWARD = {
    name: 'Digital Span Forward',
    level: [
        digitalSpanTestLevel(1, 3),
        digitalSpanLevel(1, 2),
        digitalSpanLevel(2, 3),
        digitalSpanLevel(3, 4),
        digitalSpanLevel(4, 5),
        digitalSpanLevel(5, 6),
    ],
}

export const BACKWARD = {
    name: 'Digital Span Backward',
    level: [
        digitalSpanTestLevel(1, 3),
        digitalSpanLevel(1, 2),
        digitalSpanLevel(2, 3),
        digitalSpanLevel(3, 4),
        digitalSpanLevel(4, 5),
        digitalSpanLevel(5, 6),
    ],
}